export const cofeeSupportMail = 'support@cofee.life';

export const cofeeSupportNumber = '+91-7994222356';
export const cofeeSupportNumberDisplay = '+91 7994222356 , +91 7994555243';

export const cofeeSupportMailSubject = 'Enquire on CoFee';

export const keyvalueAddress =
  'Keyvalue Software Systems Private Limited, X1/826-C09, Meda Commericial hub, Seaport Airport Road, Kakkanad, Kerala 682037';
